<template>
    <div class="app-kanban">

        <kanban-toolbar
            :mode=level
            :access="getAccessMode()"
            :publications=publications
            :boards=boards
            :boardsGroups=boardsGroups
            :board=board
            ref="toolbar"
            @allBoards="allBoards"
            @selectBoard="selectBoard"
            @addBoard="dialogBoard( defaultBoard )"
            @editBoard="dialogBoard"
            @deleteBoard="removeBoard"
            @addSection="$refs.kanban.onAddSection()"
            @addCard="startProcess"
            @favorite="favoriteBoard"
        ></kanban-toolbar>

        <div
            v-if="isAllBoards()"
            style="margin-left: calc(50% - 400px); margin-bottom: 40px; padding-top: 46px;"
        >
            <boards-navigator
                v-for="( group, index ) in groups"
                :key="index"
                :name="group.name"
                :filter="group.filter"
                :boards="boards"
                :addBoardEnabled="group.edit"
                @selectBoard="selectBoard"
                @favorite="favoriteBoard"
                @addBoard="dialogBoard( defaultBoard )"
                @editBoard="dialogBoard"
                @deleteBoard="removeBoard"
                @shareBoard="shareBoard"
            ></boards-navigator>
        </div>

        <d-kanban
            v-if="isOneBoard()"
            :access="getAccessMode()"
            :board="board"
            :lists="sections"
            :post="selfPost"
            ref="kanban"
            style="height: calc(100% - 46px);"

            @addSection="addSection"
            @changeSection="changeSection"
            @deleteSection="removeSection"

            @addCard="addCard"
            @changeCard="changeCard"
            @changeCardData="changeCardData"
            @deleteCard="removeCard"
            @openCard="openCard"
        ></d-kanban>

        <d-board-edit-dialog
            :editBoard="editBoard"
            ref="boardEditDialog"
            @ok="afterDialogBoard"
        ></d-board-edit-dialog>

        <process-control-panel
            :data="{ source: { board_id: board ? board.id : null, name: 'kanban' } }"
            :mode="processControlPanel.mode"
            :publication="processControlPanel.publication"
            :process="processControlPanel.process"
            :stepper="processControlPanel.stepper"
            :quickFinish="processControlPanel.quickFinish"
            :close="processControlPanel.close"
            :extended="processControlPanel.extended"
            :messages="processControlPanel.messages"
            :width="processControlPanel.width"
            _width="540"
            height="460"
            dateTime
            :startDate="processControlPanel.from"
            :finishDate="processControlPanel.to"
            ref="processDataForm"
            @confirm=""
            @cancel=""
            @start=""
            @finish="onProcessFinish"
            @edit="onProcessEdit"
        ></process-control-panel>

        <scope-dialog
            :board="editBoard"
            ref="scopeDialog"
        ></scope-dialog>

    </div>
</template>

<style>

    .kanban-main-menu {
        color: #eee;
        background: rgb(132, 132, 147);
        display: flex;
        height: 46px;
        /*position: relative;*/
        position: fixed;
        width: calc(100% - 65px);
        /*width: 100%;*/
        /*border-radius: 8px;*/
    }

</style>

<script>

  import DKanban from '@/components/DKanban'
  import KanbanToolbar from './KanbanToolbar.vue'
  import BoardsNavigator from './BoardsNavigator.vue'
  import ScopeDialog from './ScopeDialog.vue'
  import DBoardEditDialog from '@/components/DKanban/src/DBoardEditDialog'
  import ProcessControlPanel from '../../components/process/ProcessControlPanel'
  import { mapGetters } from 'vuex'
  import moment from 'moment'

  import apiBoard from '@/apps/bpm/kanban/api/board/api.js'
  import apiSection from '@/apps/bpm/kanban/api/section/api.js'
  import apiCard from '@/apps/bpm/kanban/api/card/api.js'
  import apiFavorite from '@/apps/bpm/kanban/api/favorite/api.js'



  /**
   * Режим интерфейса раздела - Все доски.
   *
   */
  const MODE_ALL_BOARDS = 'all-boards'

  /**
   * Режим интерфейса раздела - Одна доска.
   *
   */
  const MODE_ONE_BOARD = 'one-board'

  /**
   * Режим редактирования доски.
   *
   */
  const BOARD_EDIT_MODE = 'edit'

  /**
   * Режим просмотра доски.
   *
   */
  const BOARD_VIEW_MODE = 'view'

  /**
   *
   *
   */
  const board = {
    type: 10,
    name: '',
    description: '',
    options: null,
    scope: 'private'
  }

  /**
   * Группы досок:
   *
   *  - избранные
   *  - персональные
   *  - доступные
   *
   */
  const GROUPS = {

    favorite: {

      name: 'Избранные доски',
      type: 'favorite',
      empty: '',
      edit: false,

      init: ( boards, favoriteIds ) => {
        return boards.map( ( board ) => { board.favorite = favoriteIds.indexOf( board.id ) !== -1; return board } )
      },
      filter: ( boards ) => {
        return boards.filter( board => board.favorite === true )
      }
    },

    private: {

      name: 'Персональные доски',
      type: 'private',
      empty: '',
      edit: true,

      init: ( boards ) => {
        return boards.map( board => { board.scope = 'private'; return board } )
      },
      filter: ( boards ) => {
        return boards.filter( board => board.scope === 'private' )
      }
    },

    public: {

      name: 'Доступные доски',
      type: 'public',
      empty: '',
      edit: false,

      init: ( boards ) => {
        return boards.map( board => { board.scope = 'public'; return board } )
      },
      filter: ( boards ) => {
        return boards.filter( board => board.scope === 'public' )
      }
    }
  }

  /**
   *
   *
   */
  const PROCESS_CONTROL_PANEL_SETTINGS = {

  }



  /**
   *
   *
   */
  export default {

    /**
     *
     *
     */
    beforeRouteEnter(to, from, next) {

      // console.log(`Enter >>> `)
      //
      // console.log(`from >>> `, from.params.boardId)
      // console.log(`to >>> `, to.params.boardId)

      if ( to.params.boardId ) {

        // this.selectBoard()
      }

      // this.$router.push( this.$dmsRouteWithPost( {
      //   name: 'bpm.kanban.home'
      // } ) )

      // next(vm => {
      //   console.log( vm )
      // })

      next()
    },

    /**
     *
     *
     */
    beforeRouteUpdate(to, from, next) {

      // console.log(`Update >>> `)
      //
      // console.log(`from >>> `, from.params.boardId)
      // console.log(`to >>> `, to.params.boardId)

      next()
    },

    /**
     * Подключенные компоненты.
     *
     */
    components: {
      KanbanToolbar,
      DKanban,
      BoardsNavigator,
      DBoardEditDialog,
      ProcessControlPanel,
      ScopeDialog
    },

    /**
     * Операционные данные компонента.
     *
     */
    data () {

      return {

        level: MODE_ALL_BOARDS,

        response: null,

        board: null,

        editBoard: board,

        defaultBoard: board,

        editCard: null,

        boardName: '',

        sections: [],

        boards: [],

        boardsGroups: [],

        groups: GROUPS,

        favorites: [],

        // Публикации процессов, доступные для текущей доски.
        publications: [],

        // Настройки панели управления процессами.
        processControlPanel: {

          mode: 'finish',
          stepper: false,
          quickFinish: true,
          close: true,
          extended: false,
          publication: null,
          processId: null,
          process: null,
          messages: {
            startCaption: 'Создание задачи...',
            startSuccess: 'Задача создана!',
            finishCaption: 'Завершение задачи...',
            finishSuccess: 'Задача выполнена!',
            dataCaption: 'Данные задачи',
          }

          // start: {
          //   mode: 'start',
          //   stepper: false,
          //   quickFinish: true,
          //   close: false,
          //   publicationId: null
          // },
          //
          // finish: {
          //   mode: 'finish',
          //   stepper: false,
          //   quickFinish: true,
          //   close: false,
          //   processId: null
          // }
        }
      }
    },

    /**
     *
     *
     */
    created: function() {

      // Инициализация раздела.
      this.init()


      this.$bus.$on( 'process.start', ( data ) => {

      } )


      this.$bus.$on( 'process.finish', ( data ) => {

      } )


      this.$bus.$on( 'card.created', ( data ) => {
        this.onProcessStart( data.process_id )
      } )
    },

    /**
     *
     *
     */
    beforeDestroy: function() {


      this.$bus.$off( 'process.start', () => {

      } )


      this.$bus.$off( 'process.finish', () => {

      } )


      this.$bus.$off( 'card.created', () => {

      } )
    },

    /**
     * Вычисляемые свойства.
     *
     */
    computed: {

      ...mapGetters( 'app/account', [ 'getPost' ] ),

      /**
       *
       *
       */
      selfPost() {
        return this.getPost()
      }
    },

    /**
     *
     *
     */
    methods: {

      /**
       * Инициализация раздела.
       *
       */
      init() {

        // Получение списка доступных досок.
        return this.getBoards()
          .then( list => {
            this.boards = this.initBoards( list )
            this.setBoardsGroups( [ list.private, list.public ] )
          } )
      },

      /**
       *
       *
       */
      setProcessControlPanel() {

      },

      /**
       * Инициализация списка досок.
       *
       */
      initBoards( groups ) {

        let boards = []
        let favoriteIds = this.getFavoriteIds( groups.favorite.boards )

        boards = boards.concat( this.groups.private.init( groups.private.boards ) )
        boards = boards.concat( this.groups.public.init( groups.public.boards ) )
        boards = this.groups.favorite.init( boards, favoriteIds )

        return boards
      },

      /**
       * Текущий режим - Все доски?
       *
       */
      isAllBoards() {
        return this.level === MODE_ALL_BOARDS
      },

      /**
       * Текущий режим - Одна доска?
       *
       */
      isOneBoard() {
        return this.level === MODE_ONE_BOARD
      },

      /**
       * Переключение в режим Все доски.
       *
       */
      setAllBoards() {
        return this.level = MODE_ALL_BOARDS
      },

      /**
       * Переключение в режим Одна доска.
       *
       */
      setOneBoard() {
        return this.level = MODE_ONE_BOARD
      },

      /**
       *
       *
       */
      setBoardsGroups( boardsGroups = [] ) {

        this.boardsGroups = []

        boardsGroups.map( boardGroup => {
          this.boardsGroups.push( boardGroup )
        } )
      },

      /**
       *
       *
       */
      updateBoardsGroups( board ) {

        this.boardsGroups.forEach( boardGroup => {

          let boardIndex = boardGroup.boards.findIndex( item => item.id === board.id )

          if ( boardIndex !== -1 ) {
            this.$set( boardGroup.boards, boardIndex, board )
          }
        } )
      },

      /**
       * Получение режима работы с выбранной доской.
       *
       * Доступные режимы:
       *  - режим редактирования доски
       *  - режим просмотра доски
       *
       */
      getAccessMode() {
        return this.board && this.board.scope === 'private'
          ? BOARD_EDIT_MODE
          : BOARD_VIEW_MODE
      },

      /**
       * Получение идентификаторов избранных досок
       * из указанного списка досок.
       *
       */
      getFavoriteIds( boards ) {
        return boards.map( board => board.id )
      },

      /**
       *
       *
       */
      allBoards() {

        this.$router.push( this.$dmsRouteWithPost( {
          name: 'bpm.kanban.home'
        } ) )

        this.sections = []
        this.setAllBoards()
      },

      /**
       *
       *
       */
      dialogBoard( board ) {

        this.editBoard = board
        this.$nextTick( () => {
          this.$refs.boardEditDialog.show()
        } )
      },

      /**
       *
       *
       */
      afterDialogBoard( board ) {

        return typeof board.id === 'undefined'
          ? this.addBoard( board )
          : this.changeBoard( board )
      },

      /**
       * Обработчик выбора доски.
       *
       */
      selectBoard( board ) {

        this.setOneBoard()
        this.board = board
        this.boardName = board.name

        this.$router.push( this.$dmsRouteWithPost( {
          name: 'bpm.kanban.board',
          params: { boardId : board.id }
        } ) )

        this.getPublications( board )

        return this.getSections( board.id )
          .then( list => {
            this.sections = list

            this.$store.commit( 'app/layout/setAppLoading', false )
          } )
      },

      /**
       * Поиск индекса доски в списке досок
       * по указанному идентификатору доски.
       *
       */
      findBoardIndex( id ) {
        return this.boards.findIndex( board => id === board.id )
      },

      /**
       * Добавление / удаление избранной доски.
       *
       */
      favoriteBoard( board, isFavorite ) {

        let boardIndex = this.findBoardIndex( board.id )

        if ( boardIndex !== -1 ) {
          this.boards[ boardIndex ].favorite = isFavorite
        }

        if ( isFavorite ) {

          return apiFavorite.addFavorite( board.id )
            .then( ( data ) => {
              // console.log( data )
            } )
            .catch( ( error ) => {
              console.error( error )
            } )
        }
        else {

          return apiFavorite.deleteFavorite( board.id )
            .then( ( data ) => {
              // console.log( data )
            } )
            .catch( ( error ) => {
              console.error( error )
            } )
        }
      },

      /**
       *
       *
       */
      getPublications( board ) {

        return apiFavorite.publications( board.id )
          .then( ( data ) => {
            this.publications = data
          } )
          .catch( ( error ) => {
            console.error( error )
          } )
      },

      /**
       * Создание новой доски.
       *
       */
      addBoard( board ) {

        this.$store.commit( 'app/layout/setAppLoading', true )

        return this.createBoard( board )
          .then( id => {

            this.board = board
            this.board.id = id
            this.boardName = board.name
            this.sections = []

            // Переход в режим работы с новой доской.
            this.selectBoard( board )

            // Получение списка доступных досок.
            return this.getBoards()
          } )
          .then( list => {

            this.boards = this.initBoards( list )
            this.setBoardsGroups( [ list.private, list.public ] )
          } )
      },

      /**
       *
       *
       */
      changeBoard( board ) {

        return this.updateBoard( board )
          .then( data => {

            let index = this.findBoardIndex( board.id )

            this.$set( this.boards, index, board )
            this.board = data
            this.board.scope = 'private'
            this.boardName = data.name

            this.updateBoardsGroups( this.board )
          } )
      },

      /**
       *
       *
       */
      removeBoard( board ) {

        let dialog = {
          title: 'Удаление доски',
          message: `Вы уверены, что хотите удалить доску «${board.name}»?`
        }

        this.$dmsAgree( dialog )
          .then( () => {

            return this.deleteBoard( board.id )
          } )
          .then( () => {

            this.board = null
            this.boardName = ''
            this.sections = []

            // Получение списка доступных досок.
            return this.getBoards()
          } )
          .then( list => {

            this.boards = this.initBoards( list )
            this.setBoardsGroups( [ list.private, list.public ] )
          } )
          .catch( () => {} )
      },

      /**
       *
       *
       */
      shareBoard( board ) {

        this.editBoard = board

        this.$nextTick( () => {
          this.$refs.scopeDialog.show()
        } )
      },





      /**
       * Обработка события - Добавление секции.
       *
       */
      addSection( section ) {

        this.createSection( section.board_id, section )
          .then( id => {
            section.id = id
            this.$refs.kanban.addSection( section )
          } )
      },

      /**
       *
       *
       */
      changeSection( section ) {

        this.updateSection( section.board_id, section )
          .then( id => {

          } )
      },

      /**
       *
       *
       */
      removeSection( id ) {

        this.deleteSection( this.board.id, id )
          .then( () => {
            this.$refs.kanban.deleteSection( id )
          } )
      },

      /**
       * Поиск индекса списка в текущей доске
       * по указанному идентификатору списка.
       *
       */
      findSectionIndex( id ) {
        return this.sections.findIndex( section => id === section.id )
      },



      /**
       *
       *
       */
      startProcess( publication ) {

        this.processControlPanel.mode = 'start'
        this.processControlPanel.publication = publication
        this.processControlPanel.width = 680

        let fromDate = moment()
        this.processControlPanel.from = fromDate.format( 'YYYY-MM-DD HH:mm' )
        fromDate.add( 30, 'minutes' )
        this.processControlPanel.to = fromDate.format( 'YYYY-MM-DD HH:mm' )

        this.$nextTick( () => {
          this.$refs.processDataForm.show()
        } )
      },

      /**
       * Обработчик запуска процесса.
       *
       */
      onProcessStart( process ) {

        let id = typeof process === 'object'
          ? process.id
          : process

        return apiCard.find( id )
          .then( response => {
            this.$refs.kanban.addCard( response.item )
          } )
          .catch( () => {
            console.log( `Задача поставлена другому исполнителю` )
          } )
      },

      /**
       * Обработчик завершения процесса.
       *
       */
      onProcessFinish( processId ) {

        let card = this.editCard
        this.editCard = null

        if ( !card ) {
          return null
        }

        return this.updateCard( card.board_id, card )
          .then( card => {
            this.$refs.kanban.changeCard( card )
          } )
      },

      /**
       * Обработчик изменения процесса.
       *
       */
      onProcessEdit( process ) {

        return apiCard.find( process.id )
          .then( response => {
            this.$refs.kanban.changeCard( response.item )
          } )
          .catch( () => {
            this.$refs.kanban.deleteCardByProcessId( process.id )
          } )
      },

      /**
       * Обработка события - Добавление карточки.
       *
       */
      addCard( card ) {

        this.createCard( card.board_id, card )
          .then( id => {
            card.id = id
            this.$refs.kanban.addCard( card )
          } )
      },

      /**
       * Обработка события - Изменение карточки.
       *
       */
      changeCard( card ) {

        let sectionIndex = this.findSectionIndex( card.section_id )
        let section = this.sections[ sectionIndex ]
        let toFinish = section && section.options && section.options.type === 'finish'
        let isFinished = card.process.status_name === 'finished'
        let isCanceled = card.process.status_name === 'canceled'

        if ( toFinish && !isFinished && !isCanceled ) {

          this.editCard = card

          this.processControlPanel.mode = 'finish'
          // this.processControlPanel.processId = card.process_id
          this.processControlPanel.process = card.process
          this.processControlPanel.width = 680

          this.$nextTick( () => {
            this.$refs.processDataForm.show()
          } )
        }
        else {

          return this.updateCard( card.board_id, card )
            .then( card => {
              this.$refs.kanban.changeCard( card )
            } )
        }
      },

      /**
       *
       *
       */
      changeCardData( card ) {

        this.processControlPanel.mode = 'edit'
        this.processControlPanel.process = card.process
        this.processControlPanel.width = 680

        this.$nextTick( () => {
          this.$refs.processDataForm.show()
        } )
      },

      /**
       *
       *
       */
      openCard( card ) {

        this.processControlPanel.mode = 'data'
        // this.processControlPanel.processId = card.process_id
        this.processControlPanel.process = card.process
        this.processControlPanel.width = 680

        this.$nextTick( () => {
          this.$refs.processDataForm.show()
        } )
      },

      /**
       *
       *
       */
      removeCard( sectionId, id ) {

        this.deleteCard( this.board.id, id )
          .then( () => {
            this.$refs.kanban.deleteCard( sectionId, id )
          } )
      },





      /**
       *
       *
       */
      getBoards() {

        return apiBoard.list()
          .then( data => {

            return data.list
          } )
          .catch( ( error ) => {

            console.error( error )
          } )
      },

      /**
       *
       *
       */
      getBoard( id ) {

        return apiBoard.item( id )
          .then( ( data ) => {

            return data.item
          } )
          .catch( ( error ) => {

            console.error( error )
          } )
      },

      /**
       *
       *
       */
      createBoard( data ) {

        return apiBoard.create( data )
          .then( data => {

            return data.id
          } )
          .catch( ( error ) => {

            console.error( error )
          } )
      },

      /**
       *
       *
       */
      updateBoard( data ) {

        return apiBoard.update( data )
          .then( data => {

            return data.item
          } )
          .catch( ( error ) => {

            console.error( error )
          } )
      },

      /**
       *
       *
       */
      deleteBoard( id ) {

        return apiBoard.delete( id )
          .then( () => {

            // Переключение в режим Все доски
            this.setAllBoards()
          } )
          .catch( ( error ) => {

            console.error( error )
          } )
      },





      /**
       *
       *
       */
      getSections( boardId ) {

        return apiSection.list( boardId )
          .then( data => {

            return data.list
          } )
          .catch( ( error ) => {

            console.error( error )
          } )
      },

      /**
       *
       *
       */
      getSection( id ) {

        apiSection.item( id )
          .then( ( response ) => {

            this.response = response
          } )
          .catch( ( error ) => {

            console.error( error )
          } )

        return 'getSection'
      },

      /**
       *
       *
       */
      createSection( boardId, data ) {

        return apiSection.create( boardId, data )
          .then( data => {

            return data.id
          } )
          .catch( ( error ) => {

            console.error( error )
          } )
      },

      /**
       *
       *
       */
      updateSection( boardId, data ) {

        return apiSection.update( boardId, data )
          .then( data => {

            return data.item
          } )
          .catch( ( error ) => {

            console.error( error )
          } )
      },

      /**
       *
       *
       */
      deleteSection( boardId, id ) {

        return apiSection.delete( boardId, id )
          .then( data => {

            return data.id
          } )
          .catch( ( error ) => {

            console.error( error )
          } )
      },





      /**
       *
       *
       */
      getCards( boardId ) {

        return apiCard.list( boardId )
          .then( response => {

            this.response = response
          } )
          .catch( ( error ) => {

            console.error( error )
          } )
      },

      /**
       *
       *
       */
      getCard( boardId, id ) {

        return apiCard.item( boardId, id )
          .then( ( response ) => {

            this.response = response
          } )
          .catch( ( error ) => {

            console.error( error )
          } )
      },

      /**
       *
       *
       */
      createCard( boardId, data ) {

        return apiCard.create( boardId, data )
          .then( data => {

            return data.id
          } )
          .catch( ( error ) => {

            console.error( error )
          } )
      },

      /**
       *
       *
       */
      updateCard( boardId, data ) {

        return apiCard.update( boardId, data )
          .then( data => {

            return data.item
          } )
          .catch( ( error ) => {

            console.error( error )
          } )
      },

      /**
       *
       *
       */
      deleteCard( boardId, id ) {

        return apiCard.delete( boardId, id )
          .then( data => {

            return data.id
          } )
          .catch( ( error ) => {

            console.error( error )
          } )
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/apps/bpm/kanban/components/Kanban.vue